__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@patternslib/pat-leaflet";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("jquery", "3.7.1", function() { return __webpack_require__.e(692).then(function() { return function() { return __webpack_require__(4692); }; }); });
			register("leaflet-geosearch", "4.2.0", function() { return Promise.all([__webpack_require__.e(294), __webpack_require__.e(800)]).then(function() { return function() { return __webpack_require__(8294); }; }); });
			register("leaflet-minimap", "3.6.1", function() { return Promise.all([__webpack_require__.e(800), __webpack_require__.e(395)]).then(function() { return function() { return __webpack_require__(4395); }; }); });
			register("leaflet-providers", "2.0.0", function() { return Promise.all([__webpack_require__.e(235), __webpack_require__.e(800)]).then(function() { return function() { return __webpack_require__(3235); }; }); });
			register("leaflet-sleep", "0.5.2", function() { return __webpack_require__.e(204).then(function() { return function() { return __webpack_require__(3204); }; }); });
			register("leaflet.awesome-markers", "2.0.5", function() { return __webpack_require__.e(268).then(function() { return function() { return __webpack_require__(4268); }; }); });
			register("leaflet.fullscreen", "4.0.0", function() { return Promise.all([__webpack_require__.e(800), __webpack_require__.e(401)]).then(function() { return function() { return __webpack_require__(9401); }; }); });
			register("leaflet.locatecontrol", "0.84.2", function() { return Promise.all([__webpack_require__.e(334), __webpack_require__.e(800)]).then(function() { return function() { return __webpack_require__(4334); }; }); });
			register("leaflet.markercluster", "1.5.3", function() { return __webpack_require__.e(389).then(function() { return function() { return __webpack_require__(9389); }; }); });
			register("leaflet", "1.9.4", function() { return __webpack_require__.e(481).then(function() { return function() { return __webpack_require__(3481); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};